
import { onBeforeRouteUpdate } from 'vue-router'
export default {
  setup() {
    onBeforeRouteUpdate(to => {
      if (to.name === 'home') {
        parent.postMessage(
          {
            type: 'home'
          },
          '*'
        )
      }
      if (to.name === 'question') {
        parent.postMessage(
          {
            type: 'forword'
          },
          '*'
        )
      }
      if (to.name === 'c-result') {
        parent.postMessage(
          {
            type: 'result'
          },
          '*'
        )
      }
    })
  }
}
